import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-triangle-down",
  templateUrl: "./med-icon-triangle-down.component.html",
})
export class MedIconTriangleDownComponent extends SvgMixinComponent {}
